import { z } from "zod"

const statsEqualizerHistory = z.object({
  current: z.object({
    totalIncentives: z.number(),
    incentivesPerVote: z.number(),
  }),
  lastEpoch: z.object({
    totalIncentives: z.number(),
    incentivesPerVote: z.number(),
  }),
})

const ecosystem = z.object({
  numTokens: z.number(),
  numPairs: z.number(),
  numGauges: z.number(),
})

const statsEqualizerItem = z.object({
  history: statsEqualizerHistory,
  blockTimestamp: z.number(),
  price: z.number(),
  priceFtm: z.number(),
  priceInFtm: z.number(),
  circulatingSupply: z.number(),
  outstandingSupply: z.number(),
  dilutedSupply: z.number(),
  inNFT: z.number(),
  inGauges: z.number(),
  inExcluded: z.number(),
  veEqualTotalSupply: z.number(),
  lockRatio: z.number(),
  liquidity: z.number(),
  circulatingMarketCap: z.number(),
  marketCap: z.number(),
  fdv: z.number(),
  lockedMarketCap: z.number(),
  totalTvl: z.number(),
  totalIncentives: z.number(),
  ecosystem,
})

export const statsEqualizerResponseSchema = statsEqualizerItem

export type StatsEqualizerResponse = z.infer<typeof statsEqualizerResponseSchema>
export type StatsEqualizerResponseItem = StatsEqualizerResponse
